import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b244ff7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popups" }
const _hoisted_2 = { class: "p_contents sxjuz_j" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "c_name" }
const _hoisted_5 = { class: "c_qiu" }
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_dialog, {
      show: $setup.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.show) = $event)),
      width: "95%",
      showConfirmButton: false,
      overlay: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", { src: $setup.zuqiu }, null, 8 /* PROPS */, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: _normalizeClass($setup.msgdata.position == 1 ? 'jin' : '')
            }, [
              _createTextVNode(_toDisplayString($setup.msgdata.home_name) + " ", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString($setup.msgdata.home_score), 1 /* TEXT */)
            ], 2 /* CLASS */),
            _createElementVNode("p", {
              class: _normalizeClass($setup.msgdata.position == 2 ? 'jin' : '')
            }, [
              _createTextVNode(_toDisplayString($setup.msgdata.away_name) + " ", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString($setup.msgdata.away_score), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createCommentVNode(" <p>{{ $t('jinqiu') }}</p> "),
              _createElementVNode("p", null, _toDisplayString($setup.msgdata.title), 1 /* TEXT */),
              _createElementVNode("p", null, _toDisplayString($setup.msgdata.time), 1 /* TEXT */)
            ]),
            _createElementVNode("div", {
              class: "x",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.show = false))
            }, "x")
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ]))
}